import { ClockCounterClockwiseIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import {
  SearchResultButton,
  SearchResultList,
} from "@/components/SearchResultList/SearchResultList";
import { usePreviousCitySearches } from "@/hooks/usePreviousSearches";
import type { City } from "@/types/types";

type Props = {
  onClick: (location: City) => void;
};

export function LastSearchedCityList({ onClick }: Props) {
  const intl = useIntl();
  const { previousSearches, removePreviousSearch } = usePreviousCitySearches();

  return (
    <>
      {previousSearches?.length > 0 ? (
        <SearchResultList<City>
          heading={intl.formatMessage({ id: "hotels.search.lastSearched" })}
          data={previousSearches}
          getItemKey={(city) => city.id}
          renderItem={(city) => (
            <SearchResultButton
              icon={ClockCounterClockwiseIcon}
              primaryText={city.name}
              secondaryText={city.countryName}
              onClick={() => onClick(city)}
              onRemove={() => removePreviousSearch(city.id)}
            />
          )}
        />
      ) : null}
    </>
  );
}
